<template>
  <div>
    <h1 class="title" :class="getTitleClass(size, lineSeparator)">
      <slot></slot>
    </h1>
    <h3 v-if="hasSubtitle" class="sub-title">
      <slot name="subtitle"></slot>
    </h3>
  </div>
</template>

<script>
  export default {
    name: 'title-component',
    props: {
      size: {
        type: Number,
        default: 3
      },
      lineSeparator: {
        type: String,
        default: ''
      }
    },
    computed: {
      hasSubtitle () {
        return this.$slots.subtitle
      }
    },
    methods: {
      getTitleClass (size, lineSeparator) {
        let classes = 'is-' + size
        if (lineSeparator) {
          classes += ' line-' + lineSeparator
        }
        return classes
      }
    }
  }
</script>

<style lang="sass" scoped>
  .sub-title
    position: relative
    top: -1rem
</style>
